import { Box, Button, Grid } from "@mui/material";
import { BsFilePlusFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import DynaGrid from "./DynaGrid";
import { FaMapLocationDot } from "react-icons/fa6";
import { FaList } from "react-icons/fa";

const ActionBar = ({
  hasPermission,
  label,
  btnLabel,
  btnPrevLabel,
  setOpen = () => { },
  showGrid = [1, 2, 3, 4, 5],
  showLocation = true,
  onBtnClick = () => { },
}) => {
  const user = useSelector((state) => state?.loginState?.auth);

  return (<>
    <Box display="flex" alignItems="center" sx={{ my: 2 }}>
      <Box fontWeight={700} fontSize={14} minWidth={200}>
        <span>{label && <>{user.main_role} / {label}</>}</span>
      </Box>
      <Box flex={1}>
        <Box display="flex" flexWrap="wrap" gap={1} alignItems="center" justifyContent="flex-end">
          {btnPrevLabel && <><Button
            onClick={() => onBtnClick("previous", 0)}
            className="btn-primary"
            size="medium">{btnPrevLabel}</Button></>}
          {(hasPermission && btnLabel) && (
            <Button
              className="btn-primary"
              size="medium"
              onClick={() => setOpen(true)}
              sx={{ borderRadius: "999px", py: 1.5, textTransform: "none", fontSize: 12 }}
            >
              {btnLabel}
            </Button>
          )}
          {showGrid.includes(1) && <DynaGrid col={2} row={2} onClick={() => onBtnClick("grid", 2)} />}
          {showGrid.includes(2) && <DynaGrid col={3} row={3} onClick={() => onBtnClick("grid", 3)} />}
          {showGrid.includes(3) && <DynaGrid col={4} row={4} onClick={() => onBtnClick("grid", 4)} />}
          {showGrid.includes(4) && <DynaGrid col={5} row={5} onClick={() => onBtnClick("grid", 5)} />}
          {showGrid.includes(5) && <FaList style={{ cursor: "pointer", color: "#8C9CAC" }}
            size={28}
            onClick={() => onBtnClick("tabular", 5)}
            onMouseOver={(e) => e.target.style.color = "#FFCC33"}
            onMouseOut={(e) => e.target.style.color = "#8C9CAC"}
          />}
          {/* {showLocation && (
            <FaMapLocationDot
              style={{ cursor: "pointer", color: "#8C9CAC", }}
              fontSize={32}
              onClick={() => onBtnClick("location", 0)}
              onMouseOver={(e) => e.target.style.color = "#FFCC33"}
              onMouseOut={(e) => e.target.style.color = "#8C9CAC"}
            />
          )} */}
        </Box>
      </Box>
    </Box>
  </>
  );
};

export default ActionBar;
